import React from 'react';
import { hydrate } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { After, ensureReady } from '@jaredpalmer/after';
import routes from 'routes';
import Template from "template/Template";
import LangProvider from "context/LangProvider";
import 'client.css';
import 'packageCss.css';
import 'assets/fonts/DinArabic.css';
import 'assets/css/tailwind.css';
function Main(_a) {
    var data = _a.data;
    function noop() { }
    if (process.env.NODE_ENV !== 'development') {
        console.log = noop;
        console.warn = noop;
    }
    return (React.createElement(BrowserRouter, null,
        React.createElement(LangProvider, null,
            React.createElement(Template, null,
                React.createElement(After, { data: data, routes: routes })))));
}
ensureReady(routes).then(function (data) { return hydrate(React.createElement(Main, { data: data }), document.getElementById('root')); });
if (module.hot) {
    module.hot.accept();
}
